import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {chechFileType} from 'src/app/shared/utils/type-checker';

enum FileErrors {
  notSupported = 'The file type is not supported',
  tooLarge = 'The selected file is too large.',
}

@Injectable({
  providedIn: 'root',
})
export class FileManagerService {
  constructor(private notifier: ToastrService) {}

  handleFileInput(
    event: Event,
    FileTypes: string[],
    allowFileSize: number | null
  ): File | null {
    const fileToUpload: File | null =
      ((event.target as HTMLInputElement).files!.item(0) as File) ?? null;
    if (!chechFileType(fileToUpload, FileTypes)) {
      this.notifier.error(FileErrors.notSupported);
      return null;
    }
    if (allowFileSize && fileToUpload.size > allowFileSize) {
      this.notifier.error(FileErrors.tooLarge);
      return null;
    }

    return fileToUpload;
  }
}
